import { createPortal } from 'react-dom';
import LanguageSwitcherModalHeader from './LanguageSwitcherModalHeader';
import LanguageSwitcherOptionList from './LanguageSwitcherOptionList';
import {
	LanguageDescription,
	LanguageModal,
	LanguageOverlay,
} from '../LanguageSwitcher.styles';

const LanguageSwitcherModal = ({
	open,
	onClose,
	selectLanguageLabel,
	translations,
	activeLang,
	onSelect,
}) => {
	if (!open) {
		return null;
	}

	return createPortal(
		<LanguageOverlay onClick={onClose}>
			<LanguageModal
				role="dialog"
				aria-label={selectLanguageLabel}
				onClick={(event) => event.stopPropagation()}
			>
				<LanguageSwitcherModalHeader
					title={translations.title}
					subtitle={translations.subtitle}
					closeLabel={translations.close}
					onClose={onClose}
				/>
				<LanguageDescription>{translations.description}</LanguageDescription>
				<LanguageSwitcherOptionList
					activeLang={activeLang}
					selectLanguageLabel={selectLanguageLabel}
					activeLabel={translations.active}
					translations={translations}
					onSelect={onSelect}
				/>
			</LanguageModal>
		</LanguageOverlay>,
		document.body,
	);
};

export default LanguageSwitcherModal;
